/*
  Riccagel Wishlist — LocalStorage based favorites
  - Adds heart button to product cards
  - Toggles favorite state on click
  - Shows count in header
  - Provides /pages/wishlist support
*/

(function () {
  const STORAGE_KEY = 'riccagel_wishlist';

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggle(handle, productData) {
    const list = getWishlist();
    const idx = list.findIndex((item) => item.handle === handle);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push({
        handle,
        title: productData.title || '',
        image: productData.image || '',
        url: productData.url || '/products/' + handle,
        addedAt: Date.now(),
      });
    }
    setWishlist(list);
    updateAllButtons();
    updateCount();
  }

  function isFavorited(handle) {
    return getWishlist().some((item) => item.handle === handle);
  }

  function createButton(handle, productData) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rk-wishlist-btn';
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.dataset.handle = handle;
    btn.dataset.title = productData.title || '';
    btn.dataset.image = productData.image || '';
    btn.dataset.url = productData.url || '/products/' + handle;
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';
    if (isFavorited(handle)) btn.classList.add('rk-wishlist-btn--active');
    return btn;
  }

  // ===== イベント委譲: 動的に挿入されたボタンも確実にハンドル =====
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.rk-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.handle;
    if (!handle) return;
    const productData = {
      title: btn.dataset.title || '',
      image: btn.dataset.image || '',
      url: btn.dataset.url || '/products/' + handle,
    };
    toggle(handle, productData);
  }, true);  // capture phase で Prestige の <a> click を抑制

  function attachToProductCards() {
    const cards = document.querySelectorAll(
      '.product-card, .product-item, [data-product-card], .card.card--product'
    );
    cards.forEach((card) => {
      if (card.querySelector('.rk-wishlist-btn')) return;

      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const handleMatch = link.href.match(/\/products\/([^?#]+)/);
      if (!handleMatch) return;
      const handle = handleMatch[1].split('/')[0];

      const titleEl = card.querySelector(
        '.product-title, .product-card__title, .product-item__title, .card__title, h3, h2'
      );
      const imageEl = card.querySelector('img');

      // タイトルが空ならハンドルから生成（例: "001m" → "001M"）
      let title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) title = handle.toUpperCase();

      const productData = {
        title: title,
        image: imageEl ? imageEl.src : '',
        url: link.href,
      };

      const btn = createButton(handle, productData);

      // ハートは画像エリア(.product-card__figure)の中に配置 → 品番テキストと重ならない
      const figure = card.querySelector('.product-card__figure, .card__media, .product-card__media');
      const target = figure || card;
      if (getComputedStyle(target).position === 'static') {
        target.style.position = 'relative';
      }
      target.appendChild(btn);
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('.rk-wishlist-btn').forEach((btn) => {
      const handle = btn.dataset.handle;
      if (!handle) return;
      btn.classList.toggle('rk-wishlist-btn--active', isFavorited(handle));
    });
  }

  function updateCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // Render the wishlist page (used on /pages/wishlist)
  function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-container]');
    if (!container) return;

    const list = getWishlist();

    if (list.length === 0) {
      container.innerHTML =
        '<div class="rk-wishlist-empty">' +
        '<p class="rk-wishlist-empty__msg">お気に入りはまだありません</p>' +
        '<p class="rk-wishlist-empty__sub">気になる色をハートで保存しましょう。</p>' +
        /* 2026-08-08 修正: /collections/color-gel は非公開で404だった。
   サイトのヘッダーメニューが「カラージェル」として使っているのと同じ
   /collections/color-gel-27g（351色・公開中）へ変更する。 */
        '<a href="/collections/color-gel-27g" class="rk-wishlist-empty__link">View Collection</a>' +
        '</div>';
      return;
    }

    const grid = document.createElement('div');
    grid.className = 'rk-wishlist-grid';

    list
      .sort((a, b) => b.addedAt - a.addedAt)
      .forEach((item) => {
        const card = document.createElement('div');
        card.className = 'rk-wishlist-card';
        // タイトルが空なら handle から復元
        const displayTitle = (item.title && item.title.trim()) || (item.handle || '').toUpperCase();
        card.innerHTML =
          '<a href="' + item.url + '" class="rk-wishlist-card__link">' +
          (item.image
            ? '<div class="rk-wishlist-card__image"><img src="' + item.image + '" alt=""/></div>'
            : '<div class="rk-wishlist-card__image rk-wishlist-card__image--placeholder"></div>') +
          '<div class="rk-wishlist-card__title">' + displayTitle + '</div>' +
          '</a>' +
          '<button class="rk-remove-fav" data-handle="' + item.handle + '">Remove</button>';
        grid.appendChild(card);
      });

    // Header with count + Clear All
    const header = document.createElement('div');
    header.className = 'rk-wishlist-toolbar';
    header.innerHTML =
      '<span class="rk-wishlist-toolbar__count">' + list.length + '件のお気に入り</span>' +
      '<button class="rk-wishlist-toolbar__clear" type="button">すべてクリア</button>';

    container.innerHTML = '';
    container.appendChild(header);
    container.appendChild(grid);

    container.querySelectorAll('.rk-remove-fav').forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.handle;
        toggle(handle, {});
        renderWishlistPage();
      });
    });

    const clearBtn = container.querySelector('.rk-wishlist-toolbar__clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (confirm('お気に入りをすべて削除しますか？')) {
          setWishlist([]);
          updateAllButtons();
          updateCount();
          renderWishlistPage();
        }
      });
    }
  }

  function attachToProductDetailPage() {
    // Only on /products/* pages
    const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const handle = m[1];

    // Avoid double-injection
    if (document.querySelector('.rk-wishlist-btn--detail')) return;

    // Find the H1 product title on the product detail page
    const titleEl = document.querySelector('h1.product-title, .product-meta__title h1, .product-title');
    if (!titleEl || titleEl.tagName !== 'H1') return;

    const productData = {
      title: titleEl.textContent.trim(),
      image: (document.querySelector('.product-gallery img, .product__media img, [class*="product"] img') || {}).src || '',
      url: window.location.pathname,
    };

    const btn = createButton(handle, productData);
    btn.classList.add('rk-wishlist-btn--detail');
    btn.setAttribute('aria-label', 'お気に入りに追加');
    titleEl.appendChild(btn);
  }

  function init() {
    attachToProductCards();
    attachToProductDetailPage();
    updateCount();
    renderWishlistPage();
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach on dynamic content updates (Shopify section editor, infinite scroll, etc.)
  const observer = new MutationObserver(() => {
    attachToProductCards();
    attachToProductDetailPage();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Expose API
  window.RiccagelWishlist = {
    get: getWishlist,
    toggle,
    isFavorited,
  };
})();
